<template>
    <div class="page-banner page1 rel scroll-container" id="homeOpeningImage" :class=" { hide: !isShow}"
    v-touch:swipe="onImageSwiper" v-touch:swipe.stop>
        <div class="home_pg0 home_fullheight">
            <div class="home_pgimg">
                <div class="page-bg"></div>
                <img :src="mobileBanner.imageUrl">
                <img src="https://resource.rcclchina.com.cn/homePage/mobile/mobileBannerCover.png" class="mobileBannerCover">
            </div>
        </div>

        <div class="home_lb">
            <div class="home_titlenav fff" style="">
                <div class="f24" style="font-size: 1rem;" :style="getTitleStyle()">{{mobileBanner.title}}</div>
                <div class="f14 mt10">
                    <span>{{mobileBanner.description}}</span>
                </div>
                <div class="home_arrowd">
                    <div class="homeArrod-img">
                        <img class="home_downarrow" src="https://resource.rcclchina.com.cn/homePage/mobile/home_downarrow.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="seconds-past" @click="hideImage()">
            <div class="seconds-bg"></div>
            <div class="seconds-content">
                <div class="few-seconds"><span class="second">{{countDown}}</span>s</div>
                <div class="seconds-txt">跳过</div>
            </div>
        </div>
    </div>
</template>

<script>
const openingImageKey = 'homeImageCookie'
import Cookies from 'js-cookie'

export default {
    name: "HomeOpeningImage",
    props: {
        mobileBanner: {
            type: Object
        }
    },
    data () {
        return {
            isShow: false,
            countDown: 4
        }
    },
    mounted() {
        setTimeout(()=>{
            this.isShow = true
            this.setCountDown()
        }, 1000)
    },
    methods: {
        hideImage () {
            try {
                if (window.gio) {
                    window.gio('track', 'HomePic1');
                }
            } catch (e) {
                console.error(e)
            }
            this.isShow = false
            Cookies.set(openingImageKey, "true", { expires: 1 })
        },
        setCountDown () {
            if (this.countDown == 0) {
                this.hideImage()
                return
            }
            this.countDown--
            setTimeout(()=> {
                this.setCountDown()
            }, 1100)
        },
        getTitleStyle(){
            return {
                'margin-top': this.mobileBanner.titlePos + '%'
            }
        },
        onImageSwiper (direction) {
            if (direction == 'top') {
                this.hideImage()
            }
        } 
    }
}
</script>

<style lang="less" scoped>
#homeOpeningImage.page1 {
    z-index: 100000;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: auto;
    height: 430px;
    background: white;
    overflow: hidden;
    transition: 0.6s;
    .home_pg0 {
        background: none;
        width: auto !important;
        margin-left: 0 !important;
        .home_pgimg {
            width: 100%;
            position: relative;
            line-height: 0;
            img {
                width: 100%;
            }
            .mobileBannerCover {
                position: absolute;
                bottom: 32px;
                left: 0;
            }
        }
    }
    .home_lb {
        position: absolute;
        width: 100%;
        top: 0;
        height: 100%;
        .home_titlenav {
            position: relative;
            top: 0;
            height: 100%;
        }
        .home_arrowd {
            position: absolute;
            width: 100%;
            margin-top: auto;
            bottom: 40px;
        }
        .homeArrod-img {
            position: absolute;
            width: 100%;
            top: -40px;
            text-align: center;
            img {
                width: 20px;
                transform: rotate(180deg);
            }
        }
    }

    .seconds-past {
        position: absolute;
        top: 50px;
        right: 15px;
        padding: 3px 5px;
        font-size: 14px;
        color: #fff;
        text-align: center;
        z-index: 11;
        .seconds-bg {
            position: absolute;
            width: 100%;
            height: 100%;
            background: #000;
            opacity: .3;
            border-radius: 5px;
            top: 0;
            left: 0;
        }
        .seconds-content {
            position: relative;
            z-index: 1;
        }
    }

    .seconds-content .few-seconds, .seconds-content .seconds-txt {
        display: inline-block;
        vertical-align: top;
    }
}

#homeOpeningImage.page1.hide {
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
}
</style>